
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"25","fill":"none"}},[_c('path',{attrs:{"fill":"#fff","stroke":"#fff","stroke-miterlimit":"10","stroke-width":".5","d":"M19.3 7.4l-4.2-4.2c-.5-.4-1.1-.7-1.8-.7H7.5C6.1 2.5 5 3.6 5 5v15c0 1.4 1.1 2.5 2.5 2.5h10c1.4 0 2.5-1.1 2.5-2.5V9.2c0-.7-.3-1.3-.7-1.8zm-5.5-3.5c.2 0 .3.1.5.3l4.1 4.1c.2.2.2.3.3.5h-4.3c-.4 0-.6-.3-.6-.6V3.9zm5 16.1c0 .7-.6 1.2-1.2 1.2h-10c-.7 0-1.2-.5-1.2-1.2V5c0-.7.5-1.2 1.2-1.2h5v4.4c0 1.1.8 1.9 1.9 1.9h4.4V20h-.1zm-10-6.9c0 .4.3.6.6.6h6.2c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H9.4c-.4 0-.6.3-.6.6zm6.8 1.9H9.4c-.4 0-.6.3-.6.6 0 .4.3.6.6.6h6.2c.3 0 .6-.3.6-.6s-.3-.6-.6-.6zm0 2.5H9.4c-.4 0-.6.3-.6.6 0 .4.3.6.6.6h6.2c.3 0 .6-.3.6-.6s-.3-.6-.6-.6z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      